import { SafeAreaView } from "react-native";
import React from "react";

import {styles} from "./styles";
import FlagLogoIcon from "../icons/FlagLogoIcon";

export const FlagHeader = () => {
    return (
        <SafeAreaView style={styles.flagHeaderView}>
            <FlagLogoIcon style={styles.flagIcon}/>
        </SafeAreaView>
    )
}
